/* generated by pull.js */
const manifest = {
    editorOnly: true,
    name: 'Canvas Screenshot',
    description: 'Adds a screenshot button next to the debugger that captures the stage canvas and copies it to clipboard with a customizable sound effect.',
    tags: ['editor', 'MistWarp'],
    credits: [
        {
            name: 'Mistium'
        }
    ],
    userscripts: [
        {
            url: 'userscript.js'
        }
    ],
    userstyles: [
        {
            url: 'style.css'
        }
    ],
    settings: [
        {
            name: 'Sound effect URL',
            id: 'sound_url',
            type: 'string',
            default: ''
        },
        {
            name: 'Enable screenshot notifications',
            id: 'show_notifications',
            type: 'boolean',
            default: true
        }
    ],
    l10n: {
        en: {
            'screenshot-taken': 'Screenshot copied to clipboard!',
            'screenshot-error': 'Failed to capture screenshot',
            'screenshot-fallback': 'Screenshot captured but clipboard not supported',
            'clipboard-not-supported': 'Screenshot captured - clipboard not supported'
        }
    }
};

/* generated by pull.js */
export default manifest;
